// preventDefault on mousedown stops the button from taking focus on click.
// Without this, clicking a tool then pressing a hotkey (e.g. q) promotes
// `:focus-visible` on the previously-clicked button and the browser paints
// a stale focus ring. Tab navigation still focuses buttons via the separate
// focus event path, so keyboard users are unaffected. Wire into a styled
// button via `.attrs({ onMouseDown: noFocusOnMouseDown })`.
export function noFocusOnMouseDown(event) {
  event.preventDefault();
}

// Fetch a JSON asset that may or may not exist. Returns null if the asset
// isn't found. Parcel's dev server falls back to the SPA index.html for
// missing paths — so a naïve `r.ok ? r.json() : null` sees a 200 response
// with HTML and throws a JSON parse error. We guard on the content-type
// header and swallow parse failures to keep "this optional file isn't
// there" from turning into a fatal error.
export async function fetchOptionalJson(url) {
  let response;
  try {
    response = await fetch(url);
  } catch {
    return null;
  }
  if (!response.ok) return null;
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.toLowerCase().includes("json")) return null;
  try {
    return await response.json();
  } catch {
    return null;
  }
}
